import React from 'react'
import { Row } from 'reactstrap'

const PageContainer = ({children}: {children: React.ReactNode}) => {
    return(
        <Row className='page-content'>
            {children}
        </Row>
    )
}
export default PageContainer